import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { makeContainerStyles } from '../styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Hidden } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import NoContent from '../Shared/NoContent';
import UserMenu from './UserMenu';
import SkillCard from './SkillCard';
import T from 'i18n-react';

const useStyles = makeStyles((theme) => ({
  root: {
    ...makeContainerStyles(theme),
    margin: 'auto',
    minHeight: '70vh',
  },
  title: {
    marginBottom: theme.spacing(5),

    fontSize: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2rem',
    },
  },
  skillContainer: {
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      margin: '-12px auto',
    },
  },
}));

const Skills = ({ skills = [] }) => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Grid container>
        <Grid item xs={12} sm={4}>
          <Hidden xsDown implementation="css">
            <UserMenu />
          </Hidden>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Typography className={classes.title} variant="h4">
            あなたのスキル
          </Typography>
          <Grid
            container
            alignItems="center"
            spacing={3}
            className={classes.skillContainer}
          >
            {skills.length === 0 ? (
              <NoContent
                descriptionNode={
                  <Grid container justify="center">
                    <Grid item xs={12}>
                      {T.translate('user.skills.noContent.firstLine')}
                    </Grid>
                    <Grid item xs={12}>
                      {T.translate('user.skills.noContent.secondLine')}
                    </Grid>
                  </Grid>
                }
              />
            ) : (
              skills.map((skill, index) => (
                <SkillCard skill={skill} key={`user-skills${index}`} />
              ))
            )}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

Skills.propTypes = {
  skills: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    }),
  ),
};

export default Skills;
